<template lang="pug">
.header(:class="{ searchFocus, shown, flexy: !doco }")
  .logo(:class="{ twoFilters }", @click="home")
  .cart-count(v-show="(selected || []).length && !lens", :class="{ open: shown }", @click="shown = !shown") {{ (selected || []).length }}
  .toggles(:class="{ shown: true || folderDoco }")
    .toggle(:class="{ on: insightsShown, hide: chartShown || !folderDoco || watchlistShown }", @click="insightsShown = !insightsShown", :title="`${ insightsShown && 'hide' || 'show' } insights`")
      .goto-insights &curren;
      .label talking points
    .toggle(:class="{ on: roboWeaveShown, hide: !robo || chartShown || !folderDoco || watchlistShown }", @click="roboWeaveShown = !roboWeaveShown", :title="`${ roboWeaveShown && 'hide' || 'show' } robo weave`")
      .toggle-robo
        .bars
          .bar.tall.gap
          .bar
          .bar
          .bar.tall
          .bar.gap
          .bar.tall
          .bar
          .bar.tall
          .bar.tall
        .eyes
          .eye
          .eye
      .label robo weave
    .toggle(:class="{ on: chartShown && !roboReportShown, hide: !robo || watchlistHideAnalytics }", title="explore visualizations", @click.stop="toggleChart")
      .charts(@click.stop="toggleChart")
      .label visualizations
    .toggle(title="scroll to pdf viewer", @click="scrollToPDF", v-if="!roboWeaveShown", :class="{ hide: chartShown }")
      .goto-pdf pdf
      .label viewer
    .toggle(:title="`${ watchlistShown && 'hide' || 'show' } watchlist`",
            @click="toggleWatchlist",
            v-if="roboWeaveShown && roboWeaveTitle && Object.keys(watchlist || {}).length",
            :class="{ on: watchlistShown, hide: chartShown }")
      .goto-pdf wl
      .label watch list
    .toggle(v-if="!roboWeaveShown && (previousFolder || nextFolder)", title="previous and next folders", @mouseenter="folderPreviewsShown = true", @mouseleave="folderPreviewsShown = false", :class="{ hide: chartShown }")
      .goto-prev-next
        span.previous(:class="{ dim: !previousFolder }", @click="clickPreviousFolder", @mouseenter="enterFolder(previousFolder)", @mouseleave="leaveFolder" :title="previousFolder  && `previous folder: ${ previousFolder }` || ''") &lsaquo;&nbsp;
        span.next(:class="{ dim: !nextFolder }", @click="clickNextFolder", @mouseenter="enterFolder(nextFolder)", @mouseleave="leaveFolder" :title="nextFolder && `next folder: ${ nextFolder }` || ''") &rsaquo;
      .label previous &mdash; next
      .preview-folders(:class="{ shown: folderPreviewsShown }")
        .bg
        .preview-folder(:class="{ highlight: folderHovered === previousFolder }", :title="previousFolder  && `previous folder: ${ previousFolder }` || ''")
          folder(v-if="previousFolder", :button="true" :_key="previousFolder", :item="folderLiteCache[previousFolder]")
            .mask(v-if="previousFolder")
            .arrow &lsaquo;
        .preview-folder(:class="{ highlight: folderHovered === nextFolder }", :title="nextFolder && `next folder: ${ nextFolder }` || ''")
          folder(v-if="nextFolder", :button="true" :_key="nextFolder", :item="folderLiteCache[nextFolder]")
            .mask(v-if="nextFolder")
            .arrow &rsaquo;
    report-opener.small(v-if="watchlistShown && Object.keys(watchlist || {}).length && !roboReportShown", @click="openReport")
    .toggle(title="Open custom ESG report",
            @click="openESGReport",
            v-if="watchlistShown && Object.keys(watchlist || {}).length && !watchlistHideESG",
            :class="{ hide: chartShown }")
      .goto-pdf esg
      .label ESG report
    .toggle(v-for="{ label, theme } in watchlistCustomActions", :title="`Open ${ theme.trim().replace(/\\sthemes$/, '') } report`",
      @click="openCustomReport(theme)",
      v-if="watchlistShown && Object.keys(watchlist || {}).length && Object.keys(watchlistCustomActions || {}).length",
           :class="{ hide: chartShown }")
      .goto-pdf {{ label }}
      .label {{ theme.replace(/\sthemes$/, '') }} report
  //-.toggles.shown(v-if="!folderDoco")
  //-  .toggle(title="scroll to pdf viewer", @click="scrollToPDF", v-if="analytics")
  //-    .goto-pdf pdf
  //-    .label viewer

  .links(v-if="doco")
    a(@click="scrollToUpper", v-if="!lens") Themes
    a(@click="scrollToLower", v-if="!lens") {{ cloud && 'Topics' || pdfView && 'Viewer' || 'Insights' }}
    //- a Topics
  .links.cheatsheet(v-else)
    //a {{ pdfView && 'Viewer' || 'Cheat Sheet' }}
    a(v-if="!lens && hasCheatsheetPages && (!groupBy || editing)", @click="scrollToUpper") Pages
    a(v-if="!lens && playlist && playlist.length", @click="scrollTo('.video-section')") Videos
    a(v-if="!lens && hasInsightDocs && (!groupBy || editing) || pdfView", @click="scrollToLower") {{ cloud && 'Topics' || hasInsightDocs && (!groupBy || editing) && !pdfView && 'Insights' || 'Viewer' }}
    a(v-if="!lens && loadedDocuments && loadedDocuments.length", @click="scrollTo('.document-section')") Documents
    a(v-if="!lens && loadedTweets && loadedTweets.length", @click="scrollTo('.tweet-section')") Tweets
    a(v-if="!lens && loadedFeeds && loadedFeeds.length", @click="scrollTo('.feed-section')") Feeds
  //media-buttons.for-large(:toggleVideos="toggleVideos")
  .bar(:class="{ shown, cloud, videosShown, tweetsShown }")
    //-label.search(v-if="!cloud", :class="{ open: searchFocus }")
      input(v-model="query", type="search", @focus="searchFocus = true", @blur="blur")
    //.filters(v-if="selectedTagsLength", :class="{ searchFocus, hide: videosShown || tweetsShown || documentsShown }")
      .filter.command(v-if="cloud === false", @click="cloud = true")
      .filter.tag(@click="untag(text)",
                  v-for="(value, text) in selectedTags") {{ text }}
    //.open(v-else-if="cloud === false", @click="cloud = true", :class="{ searchFocus, hide: videosShown || tweetsShown || documentsShown  }") Filter
    //- global-events(@keyup.enter="shift")
    //button-tab.tall.right.settings-button-tab(id="settings", v-if="!cloud && (videosShown || tweetsShown || documentsShown)")
      template(slot="title")
        .settings
      template(slot="content")
        .collapse
          label.switch-light.switch-candy
            input(type="checkbox", v-model="collapse")
            strong Collapse Tags
            span
              span Off
              span On
              a
    //label.search(v-if="!cloud", :class="{ open: searchFocus }")
      //- todo: find out why this is hidden on subsequent visits
      input(v-model="query", type="search", @focus="searchFocus = true", @blur="blur")
  .title(:title="title || 'loading...'",
         :class="{ cheatsheet: cheatsheetLP, searchFocus, oneFilter, twoFilters, framed }")
    label(v-if="cheatsheetLP && editing")
      input(v-model="loadedTitle", :placeholder="title")
    .not-edit(v-else) {{ loadedTitle || title || 'loading...' }}
  .lp(v-if="cheatsheetLP") {{ cheatsheetLP }}
  reading-list
</template>
<script>
import mediaButtons from './media-buttons';
import buttonTab from './button-tab';
import readingList from './reading-list';
import reportOpener from '@/components/report-opener';
import { mapGetters } from 'vuex';
import { vuexComputed } from '@/helpers';
export default {
  name: 'headr',
  props: {
    toggleVideos: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return { folderHovered: null };
  },
  computed: {
    ...mapGetters([
      'selectedToggler',
      'framed',
      'cheatsheetLP',
      'editing',
      'playlist',
      'loadedDocuments',
      'loadedTweets',
      'loadedFeeds',
      'editing',
      'groupBy',
      'lens',
      'folderDoco',
      'folderLiteCache',
      'roboFolder',
      'robo',
      'roboWeaveTitle',
      'analytics',
      'watchlist',
      'watchlistCustomActions',
      'watchlistHideESG',
      'watchlistHideAnalytics'
    ]),
    ...mapGetters('insightsNS', ['hasCheatsheet']),
    ...vuexComputed(
      'query',
      'shown',
      'cloud',
      'pdfView',
      'videosShown',
      'tweetsShown',
      'documentsShown',
      'roboWeaveShown',
      'notificationsShown',
      'watchlistShown',
      'insightsShown',
      'folderPreviewsShown',
      'selected',
      'selectedTags',
      'selectedTagsLength',
      'searchFocus',
      'title',
      'collapse',
      'doco',
      'loadedTitle',
      'chartShown',
      'watchlistThemesShown',
      'roboReportShown',
      'roboReportLaunchedFromWatchList',
      'watchlistThemesParentFilter',
      'selectedWatchlistThemes'
    ),
    twoFilters() {
      return this.selectedTagsLength > 1;
    },
    oneFilter() {
      return this.selectedTagsLength === 1;
    },
    hasCheatsheetPages() {
      return !!Object.keys(this.$store.getters.loadedPages || {}).length;
    },
    hasInsightDocs() {
      return !!Object.keys(this.$store.getters['insightsNS/cheatsheet']?.documents || {}).length;
    },
    previousFolder() {
      const { roboFolder, folderLiteCache } = this;
      const folders = Object.keys(folderLiteCache);
      const index = folders.indexOf(roboFolder) - 1;
      let r;
      if (folders.includes(roboFolder)) {
        r = folders[index];
      }
      return r;
    },
    nextFolder() {
      const { roboFolder, folderLiteCache } = this;
      const folders = Object.keys(folderLiteCache);
      const index = folders.indexOf(roboFolder) + 1;
      let r;
      if (folders.includes(roboFolder)) {
        r = folders[index];
      }
      return r;
    }
  },
  methods: {
    toggleChart() {
      const { chartShown, roboReportShown } = this;
      if (roboReportShown) {
        this.roboReportShown = false;
      } else {
        this.chartShown = !chartShown;
      }
    },
    async openReport() {
      this.roboReportLaunchedFromWatchList = !this.chartShown;
      await (this.selectedWatchlistThemes = {});
      await (this.watchlistThemesParentFilter = '');
      this.chartShown = this.roboReportShown = this.watchlistThemesShown = true;
    },
    async openESGReport() {
      this.roboReportLaunchedFromWatchList = !this.chartShown;
      await (this.selectedWatchlistThemes = {});
      await (this.watchlistThemesParentFilter = 'ESG themes');
      this.chartShown = this.roboReportShown = this.watchlistThemesShown = this.roboReportLaunchedFromWatchList = true;
    },
    async openCustomReport(theme) {
      await (this.selectedWatchlistThemes = {});
      await (this.watchlistThemesParentFilter = theme);
      this.chartShown = this.roboReportShown = this.watchlistThemesShown = this.roboReportLaunchedFromWatchList = true;
    },
    toggleWatchlist() {
      const { watchlistShown: shown } = this;
      if (!shown) {
        this.notificationsShown = false;
      }
      this.watchlistShown = !shown;
    },
    home() {
      this.shown = this.cloud = this.videosShown = this.tweetsShown = this.documentsShown = false;
    },
    untag(item) {
      this.store.dispatch('tag', { item, value: 0 });
    },
    blur() {
      //this.searchFocus = false;
      setTimeout(() => {
        console.log('blur');
        this.searchFocus = false;
      }, 250);
    },
    shift() {
      // todo: make a global key binding for search
      //const now = new Date() * 1;
      // console.log(`now - shiftTime`, now - shiftTime);
      // if (now - shiftTime < 750) {
      //   this.searchFocus = true;
      // }
      // shiftTime = now;
    },
    scrollToLower() {
      console.log('scrollToLower');
      // window.scrollBy(0, document.querySelectorAll('.headers')[1].getBoundingClientRect().top - 40);
      window.scrollBy({
        behavior: 'smooth',
        top: document.querySelectorAll('.analysis .headers')[0].getBoundingClientRect().top - 40
      });
    },
    scrollToPDF() {
      console.log('scrollToPDF');
      // window.scrollBy(0, document.querySelectorAll('.headers')[1].getBoundingClientRect().top - 40);
      window.scrollBy({
        behavior: 'smooth',
        top: document.querySelector('.analysis .views .viewer').getBoundingClientRect().top - 70
      });
    },
    scrollToUpper() {
      window.scrollTo({ behavior: 'smooth', top: 0 });
    },
    scrollTo(selector) {
      const section = document.querySelector(selector);
      //console.log('scrollTo', selector, section);
      if (section) {
        window.scrollBy({ behavior: 'smooth', top: section.getBoundingClientRect().top - 40 });
      }
    },
    clickPreviousFolder() {
      const { hub, previousFolder, enterFolder } = this;
      if (previousFolder) {
        hub.$emit('folder-click', previousFolder);
        setTimeout(() => this.previousFolder && enterFolder(this.previousFolder), 300);
      }
    },
    clickNextFolder() {
      const { hub, nextFolder, enterFolder } = this;
      console.log(nextFolder);
      if (nextFolder) {
        hub.$emit('folder-click', nextFolder);
        setTimeout(() => this.nextFolder && enterFolder(this.nextFolder), 300);
      }
    },
    enterFolder(key) {
      console.log('enterFolder', key);
      this.folderHovered = key || null;
    },
    leaveFolder() {
      this.folderHovered = null;
    }
  },
  components: { mediaButtons, buttonTab, readingList, reportOpener,folder: () => import('../robo/folder') },
  async mounted() {
    // try {
    //   const response = await fetch('https://s3-us-west-2.amazonaws.com/weave.ai/data/toposearchindexmap.json');
    //   const json = await response.json();
    //   this.$store.dispatch('topos', json);
    // } catch (ex) {
    //   console.log('search map load', ex);
    // }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
$brn: #8d6e4f;
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  //z-index: 20;
  z-index: 7000;
  user-select: none;
  @include large {
    display: flex;
    justify-content: space-between;
    padding: 0.35rem 0;
    background-color: white;
    box-shadow: 0 1px 3px #777;
    &.searchFocus {
      box-shadow: none;
    }
    &.crop {
      overflow: hidden;
    }
  }
  & > .toggles {
    position: absolute;
    //font-size: 1.3rem;
    top: 0.75rem;
    left: 5.25rem;
    display: grid;
    grid-template-columns: repeat(7, 2.5rem);
    //grid-column-gap: 0.25rem;
    box-sizing: border-box;
    opacity: 0;
    transition: opacity 250ms ease-in-out;
    pointer-events: none;
    &.shown {
      opacity: 1;
      pointer-events: all;
    }
    & > .toggle {
      //border: 3px solid #eee;
      border: 3px solid transparent;
      border-radius: 50%;
      height: 2rem;
      position: relative;
      cursor: pointer;
      transition: border-color 250ms ease-in-out;
      will-change: border-color;
      &:hover {
        border-color: #eee;
      }
      &.on {
        border-color: orange !important;
      }
      &.hide {
        visibility: hidden;
        pointer-events: none;
      }
      .label {
        position: absolute;
        top: 2.25rem;
        left: 50%;
        transform: translate3d(-50%, 0, 0);
        font-size: 0.65rem;
        color: $brn;
        opacity: 0;
        white-space: nowrap;
        transition: opacity 250ms ease-in-out;
        will-change: opacity;
      }
      &:hover {
        .label {
          opacity: 1 !important;
        }
      }
      & > .goto-insights {
        position: relative;
        top: 0.125rem;
        left: 0.0625rem;
        // pointer-events: none;
        /* color: transparent; */
        color: $brn;
        /* font-size: 0; */
        font-size: 1.5rem;
        height: 1.9rem;
        width: 1.9rem;
        background-color: white;
        border: 1px solid $brn;
        border-radius: 0.125rem 50% 50% 50%;
        transform: rotate(45deg) scale(0.5);
        transform-origin: center;
        text-shadow: none;
        & + .label {
        }
      }
      & > .toggle-robo {
        position: relative;
        top: 0.375rem;
        left: 0.46rem;
        width: 1.25rem;
        height: 1.25rem;
        background-color: $brn;
        border-radius: 0.25rem;
        overflow: hidden;
        .eyes {
          position: absolute;
          top: 0.25rem;
          left: 0;
          right: 0;
          display: flex;
          justify-content: space-evenly;
          .eye {
            width: 0.25rem;
            height: 0.25rem;
            background-color: white;
            border: 1px solid #282828;
            border-radius: 50%;
            & + .eye {
              background-color: orange;
            }
          }
        }
        .bars {
          position: absolute;
          width: 50%;
          left: 50%;
          .bar {
            padding-top: 0;
            height: 1px;
            background-color: white;
            margin-top: 1px;
            &.tall {
              height: 2px;
            }
            &.gap {
              margin-bottom: 2px;
            }
          }
        }
      }
      & > .charts {
        position: relative;
        top: 0.25rem;
        left: 0.3rem;
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 0.25rem;
        background: white center no-repeat url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' width%3D'48' height%3D'48' viewBox%3D'0 0 48 48'%3E%3Cpath fill%3D'%238d6e4f' d%3D'M38 6h-28c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4zm-20 28h-4v-14h4v14zm8 0h-4v-20h4v20zm8 0h-4v-8h4v8z'/%3E%3Cpath d%3D'M0 0h48v48h-48z' fill%3D'none'/%3E%3C/svg%3E");
        background-size: contain;
      }
      & > .goto-pdf {
        position: relative;
        top: 0.6rem;
        font-size: 0.6rem;
        text-transform: uppercase;
      }
      & > .goto-prev-next {
        position: relative;
        top: -0.35rem;
        font-size: 2rem;
        text-transform: uppercase;
        cursor: default;
        //pointer-events: none;
        .previous,
        .next {
          cursor: pointer;
          &:hover {
            color: orange;
          }
          &.dim {
            opacity: 0.25;
            pointer-events: none;
          }
        }
      }
      .preview-folders {
        width: 45rem;
        padding: 0.5rem;
        padding-top: 4rem;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 0.5rem;
        overflow: hidden;
        position: relative;
        pointer-events: none;
        z-index: -1;
        transform: translate3d(-2rem, -300%, 0);
        transition: transform 400ms ease-in-out 1500ms;
        will-change: transform;
        cursor: default;
        &.shown {
          transform: translate3d(-2rem, 0, 0);
          transition: transform 400ms ease-in-out 200ms;
        }
        .bg {
          position: absolute;
          top: -2rem;
          left: 0;
          width: 45.125rem;
          height: 18.75rem;
          background-color: white;
          border: 1px solid #eee;
          border-radius: 0.25rem;
        }
        //.preview-folder {
        //  pointer-events: all;
        //  position: relative;
        //  top: -1.5rem;
        //  &:hover {
        //    .mask {
        //      pointer-events: none;
        //      background-color: rgba(white, 0.5);
        //    }
        //    .arrow {
        //      color: orange;
        //    }
        //  }
        //  .mask {
        //    position: absolute;
        //    top: 0;
        //    left: 0;
        //    height: 14rem;
        //    right: 0;
        //    transition: background-color 150ms ease-in-out;
        //    will-change: background-color;
        //  }
        //  .arrow {
        //    position: absolute;
        //    top: 2rem;
        //    left: 50%;
        //    transform: translate3d(-50%, 0, 0);
        //    font-size: 8rem;
        //    color: #efefef;
        //    text-shadow: 0 0 3px #282828;
        //    transition: color 150ms ease-in-out;
        //    will-change: color;
        //  }
        //  .robo-folder {
        //    transform: scale(0.5);
        //    transform-origin: top left;
        //    margin-right: -20rem;
        //  }
        //}
      }
    }
  }
  .links {
    width: 10rem;
    position: absolute;
    left: 9rem;
    //margin-left: -20rem;
    //margin-right: -20rem;
    padding-top: 0.75rem;
    display: grid;
    grid-template-columns: repeat(2, 50%);
    &.cheatsheet {
      display: flex;
      left: 5rem;
    }
    a {
      cursor: pointer;
      display: inline-block;
      padding: 0.5rem;
      color: $brn;
      white-space: nowrap;
    }
  }
  .logo {
    cursor: pointer;
    margin: 0.35rem;
    background-color: white;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    position: relative;
    //border: 1px solid $brn;
    @include large {
      margin: 0 0.35rem;
      border-color: transparent;
    }
    @include small {
      &.twoFilters {
        opacity: 0;
      }
    }
    &::before {
      content: '\00a0';
      display: inline-block;
      border: none;
      width: 55px;
      height: 40px;
      position: relative;
      background: no-repeat center top
      url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'0 0 208 208' version%3D'1.2'%3E%3Ccircle cx%3D'104' cy%3D'104' r%3D'104' fill%3D'%23e1e1e1'/%3E%3Ccircle cx%3D'104' cy%3D'104' r%3D'92.34' stroke%3D'%238d6e4f' stroke-width%3D'5' fill%3D'%238d6e4f'/%3E%3Cpath d%3D'M83.19,149.46c1.67,4.73-1.06,8.6-6.07,8.6H63.43a13.88,13.88,0,0,1-12.17-8.6L25,75.45c-1.68-4.73,1.05-8.6,6.07-8.6H44.75a13.87,13.87,0,0,1,12.17,8.6Z' fill%3D'white'/%3E%3Cpath d%3D'M58.44 149.46c-1.68 4.73 1.06 8.6 6.07 8.6h13.68a13.86 13.86 0 0 0 12.17-8.6l26.27-74c1.68-4.73-1.06-8.6-6.07-8.6H96.88a13.86 13.86 0 0 0-12.17 8.6zm65.37 0c-1.68 4.73 1 8.6 6.07 8.6h13.68a13.88 13.88 0 0 0 12.17-8.6l26.26-74c1.68-4.73-1.05-8.6-6.07-8.6h-13.68a13.87 13.87 0 0 0-12.17 8.6z' fill%3D'%23e1e1e1'/%3E%3Cpath d%3D'M150.07,149.46c1.68,4.73-1,8.6-6.07,8.6H130.32a13.87,13.87,0,0,1-12.17-8.6l-26.27-74c-1.67-4.73,1.06-8.6,6.08-8.6h13.68a13.88,13.88,0,0,1,12.17,8.6Z' fill%3D'white'/%3E%3C/svg%3E");
      //url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'0 0 208 208' version%3D'1.2'%3E%3Ccircle cx%3D'104' cy%3D'104' r%3D'104' fill%3D'%238d6e4f'/%3E%3Ccircle cx%3D'104' cy%3D'104' r%3D'92.34' stroke%3D'%23fff' stroke-width%3D'5' fill%3D'white'/%3E%3Cpath d%3D'M83.19,149.46c1.67,4.73-1.06,8.6-6.07,8.6H63.43a13.88,13.88,0,0,1-12.17-8.6L25,75.45c-1.68-4.73,1.05-8.6,6.07-8.6H44.75a13.87,13.87,0,0,1,12.17,8.6Z' fill%3D'%23a58b71'/%3E%3Cpath d%3D'M58.44 149.46c-1.68 4.73 1.06 8.6 6.07 8.6h13.68a13.86 13.86 0 0 0 12.17-8.6l26.27-74c1.68-4.73-1.06-8.6-6.07-8.6H96.88a13.86 13.86 0 0 0-12.17 8.6zm65.37 0c-1.68 4.73 1 8.6 6.07 8.6h13.68a13.88 13.88 0 0 0 12.17-8.6l26.26-74c1.68-4.73-1.05-8.6-6.07-8.6h-13.68a13.87 13.87 0 0 0-12.17 8.6z' fill%3D'%238e6e4d'/%3E%3Cpath d%3D'M150.07,149.46c1.68,4.73-1,8.6-6.07,8.6H130.32a13.87,13.87,0,0,1-12.17-8.6l-26.27-74c-1.67-4.73,1.06-8.6,6.08-8.6h13.68a13.88,13.88,0,0,1,12.17,8.6Z' fill%3D'%23a58b71'/%3E%3C/svg%3E");
      background-size: contain;
    }
    &::after {
      content: 'spectrum';
      position: absolute;
      top: 58%;
      left: 50%;
      transform: translate3d(-50%, 0.5rem, 0);
      font-size: 0.7rem;
      color: $brn;
      font-weight: 400;
    }
  }
  .for-large {
    opacity: 0;
    @include large {
      opacity: 1;
    }
  }
  .cart-count {
    display: none;
    @include large {
      display: block;
      position: absolute;
      left: 5rem;
      top: 0.25rem;
      box-sizing: border-box;
      padding: 0.8rem 0;
      text-align: center;
      width: 3.6rem;
      height: 3.6rem;
      font-weight: 500;
      font-size: 1.5rem;
      border: 2px solid #efefef;
      border-radius: 50%;
      cursor: pointer;
      transition: border-color 200ms ease-in-out;
      &.open,
      &:hover {
        border-color: orange;
      }
    }
  }
  .bar {
    position: fixed;
    @include large {
      position: static;
      height: 2.5rem;
      order: 2;
      padding-top: 0.5rem;
    }
    top: 1.5vw;
    right: 0.25rem;
    transform: translate3d(0, 0, 0);
    transition: transform 400ms ease-in-out;
    will-change: transform;
    display: flex;
    &:not(.cloud).shown {
      transform: translate3d(0, 10vh, 0);
      @include large {
        transform: translate3d(0, 0, 0);
      }
      &.videosShown,
      &.tweetsShown {
        transform: translate3d(0, -20vh, 0);
        @include large {
          transform: translate3d(0, 0, 0);
        }
      }
    }
    .search {
      cursor: pointer;
      box-sizing: border-box;
      border: 1px solid $brn;
      border-radius: 0.5rem;
      background: white no-repeat 0.125rem 0.125rem
        url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'0 0 50 50'%3E%3Cpath fill%3D'#8d6e4f' d%3D'M23 36c-7.2 0-13-5.8-13-13s5.8-13 13-13 13 5.8 13 13-5.8 13-13 13zm0-24c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11z'/%3E%3Cpath d%3D'M32.682 31.267l8.98 8.98-1.414 1.414-8.98-8.98z'/%3E%3C/svg%3E");
      background-size: 80%;
      margin-left: 1rem;
      margin-right: 1rem;
      //padding-top: 10%;
      width: 2.5rem;
      position: relative;
      @include small {
        margin-left: 0.25rem;
        margin-right: 0.25rem;
      }
      input {
        opacity: 0;
        position: absolute;
        top: 0.4rem;
        right: 0.5rem;
        width: 12rem;
        font-size: 1.1rem;
        background-color: transparent;
        outline: none;
        border: none;
        transform: all 400ms ease-in-out;
        z-index: -1;
      }
      &.open {
        width: 15rem;
        background-size: 13.333%;
        input {
          opacity: 1;
          z-index: 1;
        }
      }
    }
    .hide {
      opacity: 0;
    }
    .filters {
      display: flex;
      &.searchFocus {
        @include small {
          opacity: 0;
        }
      }
      .filter {
        position: relative;
        padding: 0.6rem 0.8rem 0.5rem;
        background-color: white;
        color: $brn;
        border-radius: 0.5rem;
        cursor: pointer;
        margin: 0 0.5rem;
        box-sizing: border-box;
        @include small {
          margin: 0 0.25rem;
        }
        &.tag {
          padding-right: 1.5rem;
          border: 1px solid $brn;
          &::after {
            content: '\00d7';
            position: absolute;
            top: 50%;
            right: 0.6rem;
            margin-top: -0.05rem;
            transform: translate3d(0, -50%, 0);
          }
        }
        &.command {
          cursor: pointer;
          display: block;
          font-size: 0;
          padding: 0;
          color: transparent;
          height: 2.4rem;
          width: 2.4rem;
          border: 1px solid $brn;
          //border-radius: 100%;
          position: relative;
          //margin-top: 0.125rem;
          //background: $brn no-repeat center
          //url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'-128 -256 1792 1792' width%3D'100%' height%3D'100%'%3E%3Cpath fill%3D'%23fff' d%3D'm 1216,576 v 128 q 0,26 -19,45 -19,19 -45,19 H 896 v 256 q 0,26 -19,45 -19,19 -45,19 H 704 q -26,0 -45,-19 -19,-19 -19,-45 V 768 H 384 q -26,0 -45,-19 -19,-19 -19,-45 V 576 q 0,-26 19,-45 19,-19 45,-19 H 640 V 256 q 0,-26 19,-45 19,-19 45,-19 h 128 q 26,0 45,19 19,19 19,45 v 256 h 256 q 26,0 45,19 19,19 19,45 z m 320,64 Q 1536,431 1433,254.5 1330,78 1153.5,-25 977,-128 768,-128 559,-128 382.5,-25 206,78 103,254.5 0,431 0,640 0,849 103,1025.5 206,1202 382.5,1305 559,1408 768,1408 977,1408 1153.5,1305 1330,1202 1433,1025.5 1536,849 1536,640 z'/%3E%3C/svg%3E");
          //background-size: 107%;
          //transform: translate3d(20%, -75%, 0);
          //background-color: transparent;
          &::after {
            position: absolute;
            top: 50%;
            left: 50%;
            display: block;
            transform-origin: center;
            transform: rotate(45deg) translate3d(-115%, -28%, 0);
            color: $brn;
            font-size: 2rem;
            content: '\00d7';
            //text-shadow: 0 0 4px black;
          }
        }
      }
    }
    .open:not(.search) {
      position: relative;
      right: 0.5rem;
      padding: 0.6rem 0.8rem 0.6rem 1.5rem;
      background: white no-repeat 0.2rem center
        url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'-2 -256 1792 1792'%3E %3Cg transform%3D'matrix(1,0,0,-1,182.23729,1201.8983)'%3E %3Cpath fill%3D'%238d6e4f' d%3D'm 1403,1241 q 17,-41 -14,-70 L 896,678 V -64 q 0,-42 -39,-59 -13,-5 -25,-5 -27,0 -45,19 L 531,147 q -19,19 -19,45 V 678 L 19,1171 q -31,29 -14,70 17,39 59,39 h 1280 q 42,0 59,-39 z'/%3E  %3C/g%3E%3C/svg%3E");
      background-size: 25%;
      //font-weight: bold;
      color: $brn;
      z-index: 2;
      border: 1px solid $brn;
      border-radius: 0.5rem;
      cursor: pointer;
      &.searchFocus {
        @include small {
          opacity: 0;
        }
      }
    }
  }
  .title {
    position: fixed;
    top: 0;
    right: 80vw;
    // center title
    @include large {
      position: absolute;
      background-color: transparent;
      font-size: 2rem;
      left: 50%;
      &.framed {
        left: 53%;
      }
      width: 57%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      top: 0.7rem;
      transform: translateX(-50%);
      color: $brn;
    }
    //@include large {
    //  position: relative;
    //  background-color: transparent;
    //  color: $brn;
    //  font-size: 2rem;
    //  left: -12rem;
    //  top: 0.7rem;
    //}
    @include small {
      right: auto;
      left: 4rem;
      transform: translate3d(0, 0, 0);
      &.oneFilter,
      &.twoFilters {
        opacity: 0;
      }
      &.searchFocus {
        opacity: 0;
      }
    }
    color: white;
    transform: translate3d(50%, 0, 0);
    font-size: 1.1rem;
    padding: 0.125rem 0.5rem;
    border-radius: 0 0 0.25rem 0.25rem;
    background-color: rgba($brn, 0.5);
    &.cheatsheet {
      //outline: 1px solid blue;
      left: auto;
      transform: translate3d(0, 0.125rem, 0);
      right: 11rem;
    }
    & > label {
      & > input {
        width: 100%;
        font-family: inherit;
        padding: 0;
        border: none;
        border-bottom: 1px solid orange;
        font-size: 2rem;
        color: $brn;
        text-align: left;
        font-weight: 300;
        &:focus {
          outline: none;
        }
        &::placeholder {
          color: inherit;
          text-align:t inherit;
          font-weight: inherit;
        }
      }
    }
    .not-edit {
      text-align: left;
      width: 100%;
      border-bottom: 1px solid transparent;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .lp {
    position: absolute;
    top: 1rem;
    right: 2rem;
    font-size: 2rem;
    color: $brn;
  }
  .reading-list {
    position: fixed;
    right: 1rem;
    top: 1rem;
    background-color: white;
    box-shadow: 1px 1px 3px black;
    padding: 1rem;
    .items {
      display: grid;
      grid-template-columns: repeat(5, 20%);
      .item {
        width: 6rem;
        padding-top: 100%;
        margin: 0.25rem;
        background: no-repeat center;
        background-size: contain;
        background-color: white;
        outline: 2px solid #dadada;
        //box-shadow: 1px 1px 3px black;
        cursor: pointer;
        //outline: 1px solid black;
        &.selected {
          outline: 2px solid orange;
          box-shadow: 1px 1px 5px black;
          /*box-shadow: 1px 1px 3px black,
                      1px 1px 6px black,
                      1px 1px 9px black;*/
        }
      }
    }
  }
  .settings {
    display: none;
    @include large {
      display: block;
      cursor: pointer;
      /*position: absolute;*/
      /*right: 0.7rem;*/
      margin-top: -0.25rem;
      /*margin-right: 0.5rem;*/
      width: 2rem;
      height: 2rem;
      background: no-repeat center
        url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' width%3D'48' height%3D'48'%3E%3Cg transform%3D'matrix(3.3932944,0,0,3.3932521,-2.8994163,-2.8988019)'%3E%3Cpath transform%3D'matrix(1.150996,-0.252943,0.253334,1.109085,-1.33593,2.243337)' d%3D'M 9.1597054,10.535626 C 8.5353139,10.932967 7.9870803,9.7868435 7.2581623,9.9149935 C 6.5292443,10.043144 6.404799,11.307529 5.6823257,11.14698 C 4.9598523,10.98643 5.3826241,9.7883391 4.7765854,9.363532 C 4.1705467,8.9387249 3.1884949,9.7447846 2.7911548,9.1203931 C 2.3938147,8.4960015 3.5399378,7.947768 3.4117877,7.2188499 C 3.2836377,6.4899319 2.0192519,6.3654866 2.1798015,5.6430133 C 2.3403511,4.9205399 3.5384422,5.3433117 3.9632493,4.737273 C 4.3880564,4.1312344 3.5819967,3.1491825 4.2063882,2.7518424 C 4.8307798,2.3545024 5.3790133,3.5006254 6.1079314,3.3724754 C 6.8368494,3.2443253 6.9612946,1.9799395 7.683768,2.1404891 C 8.4062413,2.3010388 7.9834696,3.4991298 8.5895083,3.9239369 C 9.1955469,4.348744 10.177599,3.5426843 10.574939,4.1670759 C 10.972279,4.7914674 9.8261558,5.3397009 9.9543059,6.068619 C 10.082456,6.797537 11.346842,6.9219823 11.186292,7.6444556 C 11.025743,8.366929 9.8276515,7.9441572 9.4028444,8.5501959 C 8.9780373,9.1562345 9.7840969,10.138286 9.1597054,10.535626 z' style%3D'fill:white;fill-opacity:0;stroke-width:0.3;stroke:#8d6e4f;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' /%3E%3Cpath transform%3D'matrix(1.349611,0,0,1.189061,-2.731052,-1.723202)' d%3D'M 8.8845207,8.1769037 A 0.90417689,1.022113 0 1 1 7.0761669,8.1769037 A 0.90417689,1.022113 0 1 1 8.8845207,8.1769037 z' style%3D'fill:blue;fill-opacity:0;stroke:#8d6e4f;stroke-width:0.3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1'/%3E%3C/g%3E%3C/svg%3E");
      background-size: cover;
    }
  }
}
</style>
<style lang="scss">
.settings-button-tab {
  .tab-content {
    max-width: 25rem;
  }
}
.preview-folder {
  pointer-events: all;
  position: relative;
  top: -1.5rem;
  &:hover,
  &.highlight {
    .mask {
      pointer-events: none;
      background-color: rgba(white, 0.5);
    }
    .arrow {
      color: orange;
    }
  }
  .mask {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    //height: 14rem;
    bottom: 0;
    right: 0;
    transition: background-color 150ms ease-in-out;
    will-change: background-color;
    z-index: 400;
  }
  .arrow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    pointer-events: none;
    font-size: 24rem;
    color: #efefef;
    text-shadow: 0 0 3px #282828;
    transition: color 150ms ease-in-out;
    will-change: color;
    z-index: 401;
  }
  .robo-folder {
    transform: scale(0.5);
    transform-origin: top left;
    margin-right: -20rem !important;
    .doc {
      transform: scale(1) !important;
    }
  }
}
</style>
